import React, { ButtonHTMLAttributes } from 'react';
import { FaEdit } from 'react-icons/fa';

import { Container } from './styles';

type IEditAltProps = ButtonHTMLAttributes<HTMLButtonElement>;

const EditAlt: React.FC<IEditAltProps> = ({ ...rest }) => {
  return (
    <Container type="button" {...rest}>
      Editar <FaEdit size={16} />
    </Container>
  );
};

export default EditAlt;
